import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import vectorIcon1 from "../../../Assets/Images/Vector.png";
import vectorIcon2 from "../../../Assets/Images/format_quote-Down-icon.png";

const testimonials = [
  {
    id: 1,
    text: "We went into this knowing our requirements were not very clear. Quad Theory helped us figure things out as we went. Some iterations took time, but the system today is far better than what we started with.",
    name: "Gazi",
    title: "Operations Manager of Paragon Hotel and Resort",
    img: "https://i.ibb.co.com/S7PhGVP3/Icon-15.png",
  },
  {
    id: 2,
    text: "Honestly, I did not expect this level of involvement. There were moments where things needed rethinking, and instead of pushing back, the team slowed down and worked through it with us. That made a big difference in the final product.",
    name: "S. K. Mukhopadhyay",
    title: "CEO of Infinigent Consulting",
    img: "https://i.ibb.co.com/39MH78vP/Icon-16.png",
  },
  {
    id: 3,
    text: "I was cautious about offshore teams before starting. Communication was my biggest concern. There were a few back and forths in the beginning, but once we found our rhythm, everything became much smoother and reliable.",
    name: "Rahman Hossain",
    title: "Founder of RetailTech BD",
    img: "https://rtl.com.bd/wp-content/uploads/2022/12/Retail-Technology-Ltd-300x300.jpg",
  },
];

export default function TestimonialCards() {
  const [currentIndex, setCurrentIndex] = useState(0); // 0 → [0,1], 1 → [1,2], 2 → [2,0]
  const [isMobile, setIsMobile] = useState(false);

  // Responsive setup
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 576);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Auto-rotate every 3s
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % 3);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  // Define card pairs: [frontIndex, backIndex]
  const cardPairs = [
    [0, 1], // Show ID1 (front), ID2 (back)
    [1, 2], // Show ID2 (front), ID3 (back)
    [2, 0], // Show ID3 (front), ID1 (back)
  ];

  const [frontIdx, backIdx] = cardPairs[currentIndex];
  const frontTestimonial = testimonials[frontIdx];
  const backTestimonial = testimonials[backIdx];

  // Advance manually on click
  const handleClick = () => {
    setCurrentIndex((prev) => (prev + 1) % 3);
  };

  return (
    <div id="our-stories">
      <div
        id="stories"
        className=""
        style={{ background: "#E8F8FC", marginTop: "" }}
      >
        <div
          className="d-flex justify-content-center align-items-center flex-column"
          style={{
            paddingTop: isMobile ? "2rem" : "7rem",
            paddingBottom: isMobile ? "2rem" : "6rem",
          }}
        >
          <h4
            className="fw-semibold Tech-heading text-dark py-5"
            style={{
              marginBottom: 24,
              textAlign: isMobile ? "center" : "left",
            }}
          >
            Stories From Our Amazing Clients
          </h4>

          <div
            className="position-relative"
            style={{
              width: isMobile ? "280px" : "440px",
              height: isMobile ? "480px" : "380px",
              cursor: "pointer",
            }}
            onClick={handleClick}
          >
            {/* Front card (higher z-index, animates faster) */}
            <motion.div
              key={`front-${currentIndex}`}
              initial={{ x: isMobile ? -10 : -20, y: isMobile ? -10 : -20 }}
              animate={{ x: isMobile ? 10 : 20, y: isMobile ? 10 : 20 }}
              transition={{ duration: 1.1, ease: "easeInOut" }}
              className="position-absolute shadow rounded-4 overflow-hidden"
              style={{
                width: "100%",
                height: "100%",
                zIndex: 3,
                background: "#E8F8FC",
                border: "2px solid #ffffff",
                boxSizing: "border-box",
              }}
            >
              <div className="d-flex flex-column justify-content-between h-100">
                <div
                  style={{ paddingLeft: 24, paddingRight: 24, paddingTop: 4 }}
                >
                  <p
                    className="text-secondary fs-3"
                    style={{ marginBottom: 8 }}
                  >
                    <img src={vectorIcon2} alt="quote start" />
                  </p>
                  <p
                    className="text-secondary small d-flex justify-content-center align-items-center"
                    style={{
                      paddingTop: 24,
                      paddingBottom: 24,
                      textAlign: "justify",
                      fontSize: "1.5rem",
                    }}
                  >
                    {frontTestimonial.text}
                  </p>
                  <p
                    className="text-secondary fs-3 text-end"
                    style={{ marginBottom: 0 }}
                  >
                    <img src={vectorIcon1} alt="quote end" />
                  </p>
                </div>

                <div
                  style={{
                    backgroundColor: "#FFFFFF",
                    padding: "16px 20px",
                  }}
                  className="d-flex align-items-center"
                >
                  <img
                    src={frontTestimonial.img}
                    alt={frontTestimonial.name}
                    className="rounded-circle"
                    width={50}
                    height={50}
                    style={{ marginRight: 12 }}
                  />
                  <div>
                    <h6 className="text-dark" style={{ margin: 0 }}>
                      {frontTestimonial.name}
                    </h6>
                    <small style={{fontSize: "10px"}}>{frontTestimonial.title}</small>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Back card (lower z-index, animates slower — appears "behind") */}
            <motion.div
              key={`back-${currentIndex}`}
              initial={{ x: isMobile ? 10 : 20, y: isMobile ? 10 : 20 }}
              animate={{ x: isMobile ? -10 : -20, y: isMobile ? -10 : -20 }}
              transition={{ duration: 2.2, ease: "easeInOut" }}
              className="position-absolute shadow rounded-4 overflow-hidden"
              style={{
                width: "100%",
                height: "100%",
                zIndex: 1,
                background: "#E8F8FC",
                border: "2px solid #ffffff",
                boxSizing: "border-box",
              }}
            >
              <div className="d-flex flex-column justify-content-between h-100">
                <div
                  style={{ paddingLeft: 24, paddingRight: 24, paddingTop: 4 }}
                >
                  <p
                    className="text-secondary fs-3"
                    style={{ marginBottom: 8 }}
                  >
                    <img src={vectorIcon2} alt="quote start" />
                  </p>
                  <p
                    className="text-secondary small d-flex justify-content-center align-items-center"
                    style={{
                      paddingTop: 24,
                      paddingBottom: 24,
                      textAlign: "justify",
                      fontSize: "1.5rem",
                    }}
                  >
                    {backTestimonial.text}
                  </p>
                  <p
                    className="text-secondary fs-3 text-end"
                    style={{ marginBottom: 0 }}
                  >
                    <img src={vectorIcon1} alt="quote end" />
                  </p>
                </div>

                <div
                  style={{
                    backgroundColor: "#FFFFFF",
                    padding: "16px 20px",
                  }}
                  className="d-flex align-items-center"
                >
                  <img
                    src={backTestimonial.img}
                    alt={backTestimonial.name}
                    className="rounded-circle"
                    width={50}
                    height={50}
                    style={{ marginRight: 12 }}
                  />
                  <div>
                    <h6
                      className="text-dark"
                      style={{ margin: 0, fontSize: "1rem" }}
                    >
                      {frontTestimonial.name}
                    </h6>
                    <small
                      className="text-muted"
                      style={{
                        fontSize: "8px",
                        display: "block",
                        marginTop: "2px",
                      }}
                    >
                      {frontTestimonial.title?.trim() || "—"}
                    </small>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Indicator (3 dots / 3 positions) */}
          <div className="mt-3 py-5">
            <div
              style={{
                width: "90px",
                height: "4px",
                borderRadius: "3px",
                background: "#d9edf5",
                position: "relative",
              }}
            >
              <motion.div
                animate={{ x: currentIndex * 30 }}
                transition={{ duration: 0.6, ease: "easeInOut" }}
                style={{
                  width: "30px",
                  height: "4px",
                  borderRadius: "3px",
                  background: "#19BDDE",
                  position: "absolute",
                  left: 0,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
